import { Component } from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { isUndefined, toBoolean } from 'src/app/services/codeUtils';
import { EventsService } from 'src/app/services/event/event.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { ConfigService } from 'src/app/services/config/config.service';
import { LobbyService } from 'src/app/services/lobby/lobby.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';
import { Platform } from '@ionic/angular';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { CommonAlertService } from 'src/app/services/alert/alert.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { DeviceDetailsCollectorService } from 'src/app/services/kount/kount.service';
import { AudioService } from 'src/app/services/audio/audio.service';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
import { DeeplinkRedirectService } from 'src/app/services/deeplink-redirect/deeplink-redirect.service';
import { TrackConsentService } from 'src/app/services/tracking-consent/track-consent.service';
import { BonusCollectionService } from 'src/app/services/bonus-collection/bonus-collection.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

@Component({
	selector: 'app-init',
})

export class AppInitComponent {

	private initTriggeredBy;
	private _Que = [];
	public depositCode = '';
	public optInId = null;
	public initTime = 0;
	public customer;
	public accountBalances: any;
	public customerQualification: any;
	public geolocationPasses: boolean;
	public loading;
	public appInitNextEvent: Subscription;
	public boydSubscription: Subscription;
	public wlAgreed: boolean;
	public reconfirmPersonalDetails: boolean;

	constructor(
		private readonly galleryService: GalleryService,
		private eventsService: EventsService,
		private userSessionService: UserSessionService,
		private accountBalanceService: AccountBalanceService,
		private navigator: Navigator,
		private configService: ConfigService,
		private audioService: AudioService,
		private lobbyService: LobbyService,
		private utilsService: UtilsService,
		private boydRewardsService: BoydRewardsService,
		private platform: Platform,
		private commonAlertService: CommonAlertService,
		private kountService: DeviceDetailsCollectorService,
		private logoutService: LogoutService,
		private withdrawService: WithdrawalService,
		private deeplinkRedirectService: DeeplinkRedirectService,
		private trackService:TrackConsentService,		
		private bonusCollectionService: BonusCollectionService,	
		private authService: AuthenticationService
	) {
		if (this.platform.is("capacitor")) {
			this.deeplinkRedirectService.deeplinksListener();
		}
		this.eventsService.subscribe('event:appInit:init', (params) => {
			this.initTriggeredBy = !!params && !!params.triggeredBy ? params.triggeredBy : '';
			this.depositCode = !!params && !!params.depositCode ? params.depositCode : '';
			if (!this.initTime) {
				this.initTime++;
				setTimeout(() => this.init(), 60);
			}
		});

		this.eventsService.subscribe("event:authentication:logout", () => {
			this.eventsService.unsubscribe("event:appInit:next");
			this.initTime = 0;
			this._Que = [];
		})

		if (this.platform.is("capacitor") && this.platform.is("android")) {
			this.platform.backButton.subscribeWithPriority(100, () => {
				this.navigator.goBackOrExitApp();
			});
		}

		

	}

	init() {
		forkJoin([
			this.userSessionService.getCustomer().pipe(take(1)),
			this.accountBalanceService.getBalance().pipe(take(2)),
			this.accountBalanceService.callGetQualification('freespin').pipe(take(1)),
		]).subscribe(([customer, balance, customerQualification]) => {
			this.customer = customer;
			this.accountBalances = balance;
			this.customerQualification = customerQualification;
			this.setTheRulesAndStart();
			this.geolocationPasses = false;
			this.checkRewardCard();
		});

		this.appInitNextEvent = this.eventsService.subscribe('event:appInit:next', (data) => {
			if (!isUndefined(data) && data && !isUndefined(data.geolocationPasses)) {
				this.geolocationPasses = data.geolocationPasses;
			}
			this.popQueAndNext("event:appInit:next")
		}
		);

		this.accountBalanceService.updateBalance();
		this.withdrawService.callGetPayoutMethods();
	}

	protected setTheRulesAndStart(): any {
		//this.addTestPopup();
		const rules = this.rules();
		if (rules.customerCoolingOff()) this.addCoolOffAction();
		//if (rules.migratedPlayer()) this.addMigration();
		//if (rules.customerIncomplete()) this.addSignupStepTwo();
		//if (rules.customerKYCFail()) this.addKYCInvalid();

		if (this.initTriggeredBy == "REFRESH") {
			//if (rules.customerMFA() == 'true') this.addMFA();
			//if (rules.customerStrongAuthRequiredCheck() == 'true') this.addStrongAuthentication();
		}

		if (this.initTriggeredBy !== 'REFRESH' || location.hash == '#launchDS') {
			if (location.hash == '#launchDS') {
				this.utilsService.removeUrlParams();
			}
		}

		this.refreshContest();
		this.showLobby();

		if (!rules.customerNotActive() && this.initTriggeredBy !== 'REFRESH') {

			if (this.configService.getConfig().FEATURE_KOUNT_COLLECT_DATA === '1') {
				this.addKountDataCollectCall();
			}
			if (this.configService.getConfig().FEATURE_SHOW_BOYD_REWARDS_ON_LOGIN === '1') {
				//this.addBoydRewardEnroll();
			}
		}
		if (rules.isTrackConsentShouldDisplay()) this.requestTrackingConsent();
		this.addLobbyCheckForNotificationLoop();
		if (rules.registrationLoginWithADepositCode()) this.addRedirectToDepositPage();
		if (rules.anyPendingBonusCodeFromDeeplinks()) this.addLaunchBonusModal();
		if (rules.waitingToLaunchAGame()) this.addLaunchGame();
		if (rules.waitingToOpenModal()) this.openModalWindow();
		if (rules.registrationLoginWithAnOffer()) this.optInToOffer();
		if (this.configService.getConfig().FEATURE_CUSTOMER_RECONFIRM === '1') {
			if (rules.customerAnnualReconfirmationCheck()) {
				this.addPersonalReconfirmation();
			}
		}
		this.addNotifications();

		this._Que.reverse();
		this.next();
	}

	private checkRewardCard(): any {
        this.authService.checkPlayerHasRewardCard().subscribe(
            (response) => {
                if (response && !!response.result) {
                    this.boydRewardsService.setRewardCardStatus(response.payload);
                }
            },
            (error) => {
				this.boydRewardsService.setRewardCardStatus(false);
            }
        );
    }

	addKountDataCollectCall() {
		this._Que.push({
			name: "Kount Data Collection",
			action: () => {
				try {
					this.kountService.onDoCollectionClick();
					this.popQueAndNext("Boyd Enroll Verification");
				} catch (e) {
					console.log(e);
					this.popQueAndNext("Boyd Enroll Verification");
				}

			}
		})
	}

	addStrongAuthentication() {
		this._Que.push({
			name: "Strong Auth",
			action: () => {
				this.navigator.navigateTo("PinLoginComponent", { forceModal: true }, { customerId: this.customer.customerId, callBackFn: () => { this._Que.pop(); this.next() } })
			}
		})
	}

	private refreshContest(): void{
		this.eventsService.publish("event:load-contest");
	}

	rules() {
		let isQualified = () => {
			let data = this.customerQualification.payload;
			let pageToNavigate;

			let response: any = {
				result: true,
				pageToNavigate: pageToNavigate,
			};

			if (!!data) {
				switch (data['policy-name']) {
					case 'emailvalidation':
						pageToNavigate = 'InvalidEmailComponent';
						break;
					case 'kyc':
						pageToNavigate = 'InvalidKycComponent';
						break;
					case 'spincriteria':
						pageToNavigate = 'InvalidSpinPage';
						break;
				}
				response = {
					result: false,
					pageToNavigate: pageToNavigate,
				};
			}
			return response;
		};

		let customerNotActive = () => {
			return this.customer.status.toLowerCase() === 'active' ? false : true;
		};

		let customerIncomplete = () => {
			return this.customer.status.toLowerCase() === 'incomplete' ? true : false;
		};

		let customerKYCFail = () => {
			return this.customer.status.toLowerCase() === 'kyc_fail' ? true : false;
		};

		let customerCoolingOff = () => {
			return ('status' in this.customer && this.customer.status == 'SELF_EXCLUDED_COOL_OFF');
		};

		let customerMFA = () => {
			let mfa = localStorage.getItem('userSession.mfa');
			return mfa;
		}

		let customerStrongAuthRequiredCheck = () => {
			return localStorage.getItem('strongAuthenticationRequired');
		}
		let migratedPlayer = () => {
			const incompletePlayer: boolean = customerIncomplete();
			return !!this.customer && incompletePlayer && (this.customer.getCustomDataProperty('CRE_BY') === 'MIGRATION' || this.customer.getCustomDataProperty('CRE_BY') === 'PA_MIGRATION');
		}

		// if MFREESPIN > 0 && is not a new customer
		let hasDailySlot = () => {
			let availableSpins = 'undefined' !== typeof this.accountBalances.MFREESPIN ? this.accountBalances.MFREESPIN.availableBalance : false;
			let customerData: Array<any> = !!this.customer ? this.customer.customData : [];
			let newAccountValue = customerData.filter((x) => { return x.key === 'NEW_ACCOUNT_TASKS'; }).map((x) => x.value).reduce((value) => value, 0);
			let isNewCustomer = <string>newAccountValue === '1' ? true : false;
			let slotEnabled = this.configService.getConfig().SITE_HAS_DAILY_SLOT === '1' ? true : false;
			return availableSpins && !isNewCustomer && slotEnabled ? availableSpins : false;
		};

		let hasValidEmail = () => {
			return !!this.customer && !isUndefined(this.customer.emailValidated) && this.customer.emailValidated ? true : false;
		};

		let registrationLoginWithADepositCode = () => {
			return !!this.depositCode ? true : false;
		};

		let waitingToLaunchAGame = () => {
			return this.lobbyService.getWaitingGameData() !== null ? true : false;
		};

		let anyPendingBonusCodeFromDeeplinks = () => {
			return this.lobbyService.getPendingBonusCodes() !== null ? true : false;
		};

		let waitingToOpenModal = () => {
			return this.lobbyService.getWaitingDialogPage() !== null ? true : false;
		};

		let registrationLoginWithAnOffer = () => {
			return !!this.optInId ? true : false;
		};

		let customerAnnualReconfirmationCheck = () => {
			if (this.configService.getConfig().FEATURE_CUSTOMER_RECONFIRM === '1') {
				this.reconfirmPersonalDetails = localStorage.getItem("reconfirmPersonalDetails") !== null;
			}
			return this.reconfirmPersonalDetails;
		}

		let isTrackConsentShouldDisplay = () => {
			return this.trackService.checkTrackConsentShouldDisplay();
		}
		return {
			customerCoolingOff,
			customerIncomplete,
			customerKYCFail,
			customerMFA,
			customerNotActive,
			hasDailySlot,
			hasValidEmail,
			isQualified,
			migratedPlayer,
			registrationLoginWithADepositCode,
			customerStrongAuthRequiredCheck,
			registrationLoginWithAnOffer,
			waitingToLaunchAGame,
			anyPendingBonusCodeFromDeeplinks,
			waitingToOpenModal,
			customerAnnualReconfirmationCheck,
			isTrackConsentShouldDisplay
		};
	}


	addCoolOffAction() {
		this._Que.push({
			name: 'Customer Cool Off',
			action: () => {
				this.navigator.navigateTo('CoolingOffComponent', { forceModal: true });
			},
		});
	}

	addSignupStepTwo() {
		this._Que.push({
			name: 'Signup step 2',
			action: () => {
				this.navigator.navigateTo('SignupStepTwoComponent', { forceModal: true });
			},
		});
	}

	addMigration() {
		this._Que.push({
			name: "Customer Migration Check",
			action: () => {
				const playerMigrationPageEnabled: boolean = this.configService.getConfig().FEATURE_PLAYER_MIGRATION_WP_ENABLED ?? true;
				playerMigrationPageEnabled ?
					this.navigator.navigateTo("PlayerMigrationComponent", { forceModal: true }) :
					this.navigator.navigateTo('PlayerMigrationActionComponent', { forceModal: true });
			}
		})
	}

	addKYCInvalid() {
		this._Que.push({
			name: 'Invalid Kyc',
			action: () => {

				let kyc_step = this.customer.getCustomDataProperty('KYC_STEP');
				if (this.customer.getCustomDataProperty('IS_PEP_OR_HIO') === 'true') {
					this.commonAlertService.showPepHioAlert(undefined, this.closeModal());
				} else if (isUndefined(this.customer.governmentTypeId)) {
					//canada - we don't set governmentTypeId
					switch (kyc_step.toUpperCase()) {
						case 'PENDING_RETRY':
							this.navigator.navigateTo("CamsComponent");
							break;
						case 'PENDING_IDSCAN':
							this.navigator.navigateTo("CamsComponent");
							break;
						case "DONE":
							setTimeout(() => { this._Que.pop(); this.next() }, 500);
							break;
						default:
							this.navigator.navigateTo("CamsComponent");
							break;
					}
				} else if (isUndefined(this.customer.kyc_attempts)) {
					this.navigator.navigateTo('InvalidKycComponent', {}, { allAttemptsUsed: true });
				} else {
					let attempts = this.configService.getConfig().FEATURE_KYC_MAX_ATTEMPTS || 3;
					if (this.customer.kyc_attempts < attempts) {
						this.navigator.navigateTo('InvalidKycComponent');
					} else if (this.customer.kyc_attempts >= attempts) {
						this.navigator.navigateTo('InvalidKycComponent', {}, { allAttemptsUsed: true });
					}
				}
			},
		});
	}

	closeModal = () => {
		this.navigator.dismissAll();
		this.logoutService.onLogout({ reason: 'QUALIFICATION_KYC_FAIL' });
	};

	addMFA = () => {
		this._Que.push({
			name: "MFA",
			action: () => {
				let isSMS_OR_EMAIL = this.configService.getConfig().FEATURE_MFA_TYPE ? this.configService.getConfig().FEATURE_MFA_TYPE : 'SMS';

				if (isSMS_OR_EMAIL == 'SMS') return this.navigator.navigateTo("SmsLoginComponent", { forceModal: true }, { customerId: this.customer.customerId, callBackFn: () => { this.popQueAndNext("SmsLoginComponent") } })

				return this.navigator.navigateTo("CodeLoginPage", { forceModal: true }, { customerId: this.customer.customerId, callBackFn: () => { this.popQueAndNext("CodeLoginPage") } })
			}
		})
	}

	showLobby() {
		this._Que.push({
			name: "Show Lobby",
			action: () => {
				this.eventsService.publish("event:lobby:show");
				this.popQueAndNext("Boyd Enroll Verification");
			}
		})
	}

	addBoydRewardEnroll = () => {
		this._Que.push({
			name: 'Boyd Enroll Verification',
			action: () => {
				this.boydSubscription = this.boydRewardsService.checkConnectionToBoydCard().pipe(take(1)).subscribe(res => {
					if (!res) {
						this.navigator.navigateTo('EnrollBoydRewardsComponent', { forceModal: true }, { callBackFn: () => { this.popQueAndNext("EnrollBoydRewardsComponent") } });
					} else {
						this.popQueAndNext("EnrollBoydRewardsComponent else")
					}
				}, err => {
					this.popQueAndNext("EnrollBoydRewardsComponent error")
					console.log(err);
				});

			},
		});
	}


	addLobbyCheckForNotificationLoop() {
		this._Que.push({
			name: 'Notification listener on lobby',
			action: () => {
				if (this.loading) this.loading.dismiss();
				this.eventsService.publish('event:lobby:checkMarketingNotification');
				setTimeout(() => {
					this.popQueAndNext("Notification listener on lobby")
				}, 3000);
			},
		});
	}

	addRedirectToDepositPage() {
		this._Que.push({
			name: 'Navigate to Deposit page with code.',
			action: () => {
				this.navigator.navigateTo('DepositMainComponent', { forceModal: true }, { depositCode: this.depositCode });
			},
		});
	}

	addPersonalReconfirmation() {
		this._Que.push({
			name: 'Annual Personal Reconfirmation',
			action: () => {
				this.navigator.openPopover('PopoverReconfirmation', {}, 'standard-popover', false, true, true, -1, 'cover', true);
			},
		});
	}

	addLaunchGame() {
		this._Que.push({
			name: 'Launch a game',
			action: () => {
				let gameData = this.lobbyService.getWaitingGameData();
				if (!!gameData) {
					this.galleryService.openGameDetailPage(gameData);
				}
			},
		});
	}

	addLaunchBonusModal() {
		this._Que.push({
			name: 'Launch Bonus',
			action: () => {
				let bonusData = this.lobbyService.getPendingBonusCodes();
				if (!!bonusData) {
					this.bonusCollectionService.validateAndNavigateToCollectBonus(bonusData);
				}
			},
		});	
	}

	addTestPopup() {
		this._Que.push({
			name: 'Add test pop',
			action: () => {
				this.navigator.navigateTo('LoginComponent', { customModalClass: 'crown-modal', animated: false, backdropDismiss: true });
				//this.navigator.navigateTo('PlayerMigrationActionComponent', { forceModal: true }, { status: false });
			},
		});
	}

	addNotifications() {
		this._Que.push({
			name: "Notification Listener",
			action: () => {
				if (this.loading) this.loading.dismiss();
				this.eventsService.publish("event:notifications:start");
			}
		})
	}

	openModalWindow() {
		this._Que.push({
			name: 'Open Modal Window',
			action: () => {
				let dialogPage = this.lobbyService.getWaitingDialogPage();
				this.lobbyService.clearWaitingDialogPage();
				if (!!dialogPage) this.navigator.navigateTo(dialogPage);
			},
		});
	}

	optInToOffer() {
		this._Que.push({
			name: 'Opt-In to offer.',
			action: () => {
				let link = this.configService.getExternalLinks().payload.find((link) => link.code == this.optInId);
				this.eventsService.publish('event:webview:load', link.url);
			},
		});
	}

	requestTrackingConsent() {
		this._Que.push({
			name: 'Tracking Consent',
			action: () => {
				this.trackService.checkAdvertisingStatus();
			},
		});
	}

	next() {
		this.userSessionService.isAuthenticated().then((isAuthenticated) => {
			if (!isAuthenticated) return;

			if (this._Que.length) {
				let next = this._Que[this._Que.length - 1];
				if (!isUndefined(next) && 'action' in next) {
					//console.log("AppInit: ", next.name);
					next.action();
				}
			} else {
				this.onFinish();
			}
		});
	}

	onFinish() {
		if (this.loading) this.loading.dismiss();
		this.appInitNextEvent.unsubscribe();
		//this.navigator.dismissAll();
	}

	popQueAndNext(name) {
		let action = (!!name ? name : "no name")
		//console.log("App Init call next: ", name)
		this._Que.pop();
		this.next();
	}

}
